import { request } from "../client";

export interface VoiceInfo {
  id: string;
  name: string;
  language: string;
  gender: string;
  tier?: string;
  isActive?: boolean;
}

export interface VoicesResponse {
  voices: VoiceInfo[];
  voicesByLanguage: Record<string, VoiceInfo[]>;
  totalAvailable: number;
  userTier: string;
  languages: string[];
}

export interface VoiceAccessResponse {
  voiceId: string;
  voice: VoiceInfo;
  canAccess: boolean;
  reason: string;
  userTier: string;
  requiredTier: string;
}

export function createVoicesEndpoints(baseUrl: string): {
  list: (token?: string | null) => Promise<VoicesResponse>;
  listByLanguage: (
    language: string,
    token?: string | null,
  ) => Promise<{ voices: VoiceInfo[]; language: string }>;
  check: (
    voiceId: string,
    token?: string | null,
  ) => Promise<VoiceAccessResponse>;
} {
  return {
    list(token?: string | null): Promise<VoicesResponse> {
      return request<VoicesResponse>(baseUrl, "/voices", {
        method: "GET",
        token,
      });
    },
    listByLanguage(
      language: string,
      token?: string | null,
    ): Promise<{ voices: VoiceInfo[]; language: string }> {
      return request<{ voices: VoiceInfo[]; language: string }>(
        baseUrl,
        `/voices/language/${language}`,
        { method: "GET", token },
      );
    },
    check(
      voiceId: string,
      token?: string | null,
    ): Promise<VoiceAccessResponse> {
      return request<VoiceAccessResponse>(baseUrl, `/voices/${voiceId}/check`, {
        method: "GET",
        token,
      });
    },
  };
}
